export function initJsFluidMultipliers(options = {}) {
  const defaults = {
    root: document.documentElement,
    xl: 1400,
    lowMin: 320,
    highMax: 3800,
    multipliers: {
      '1-25': 1.25,
      '1-5': 1.5,
      2: 2,
      '2-5': 2.5,
      3: 3,
      4: 4,
    },
    precision: 6,
    listen: true,
    clampToMaxScreen: true,
    alias: '2',
  };

  const cfg = { ...defaults, ...options };
  const style = cfg.root.style;
  const toFixed = (n) => n.toFixed(cfg.precision);

  const vw = () =>
    Math.max(0, document.documentElement.clientWidth || window.innerWidth || 0);

  const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

  function computeState() {
    const rawScreen = vw();
    const screen = cfg.clampToMaxScreen
      ? Math.min(rawScreen, cfg.highMax)
      : rawScreen;
    const inLowRange = screen < cfg.xl;
    const min = inLowRange ? cfg.lowMin : cfg.xl;
    const max = inLowRange ? cfg.xl : cfg.highMax;
    const bp = clamp((screen - min) / (max - min), 0, 1);
    return { bp };
  }

  function valueFromTarget(target, bp) {
    return 1 + (target - 1) * bp;
  }

  function applyVars({ bp }) {
    const computed = {};
    for (const [key, target] of Object.entries(cfg.multipliers)) {
      const v = valueFromTarget(target, bp);
      computed[key] = v;
      style.setProperty(`--js-fld-${key}`, toFixed(v));
    }

    const aliasKey = cfg.alias in cfg.multipliers ? cfg.alias : '2';
    style.setProperty('--js-fld', toFixed(computed[aliasKey]));
  }

  function update() {
    applyVars(computeState());
  }

  // Initial run
  update();

  let raf = 0;
  function onResize() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(update);
  }

  if (cfg.listen) {
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });
  }

  function destroy() {
    if (!cfg.listen) return;
    window.removeEventListener('resize', onResize);
    window.removeEventListener('orientationchange', onResize);
  }

  return { destroy };
}
